import { BlockCall } from '@services/api/block-calls'
import { AdsIndexDto } from '@services/api/ads/types'

export interface Parent {
  id: number
  name: string
  slug: string
}

export interface Editorial {
  id: number
  slug: string
  name: string
  parent: Parent
  path?: string
}

export interface Tag {
  id: number
  name: string
  slug: string
  path: string
}

export interface SocialMedia {
  email: string
  facebook: string
  instagram: string
  linkedin: string
  twitter: string
}

export interface Author {
  id: number
  name: string
  slug: string
  email: string
  path: string
  biography: string
  avatar: string
  socialMedia: SocialMedia
}

export interface File {
  url: string
}

export interface Data {
  text: string
  level?: number
  file: File
  caption: string
  alt: string
  withBorder?: boolean
  stretched?: boolean
  withBackground?: boolean
}

export interface Block {
  type: string
  data: Data
}

export interface Content {
  time: number
  blocks: Block[]
  version: string
}

export interface CoverImage {
  path: string
  description: string
  alt: string
}

export interface ThumbnailImage {
  path: string
  alt: string
}

export enum ArticleType {
  ARTICLE = 'article',
  VIDEO = 'video'
}
export interface Article {
  id: number
  slug: string
  title: string
  editorial: Editorial
  editorialAscendent?: Editorial
  thumbnailImage: ThumbnailImage
  tags: Tag[]
  authors?: Author[]
  shortContent?: string
  metaDescription: string
  metaTitle: string
  canonicalUrl: string
  content?: Content
  coverImage: CoverImage
  createdAt: Date
  publishedAt: string
  modificationDate: Date
  timeToRead: number
  path: string
  articleType: ArticleType
  videoUrl: string
  blockCalls?: BlockCall
  keywords?: string
  ads?: AdsIndexDto[]
  simulatorDesktopImages?: BlockCall[]
  simulatorMobileImages?: BlockCall[]
}
